import { useStorageItem } from './useStorageItem'
import { StorageKey } from './useLocalStorageItemHelper'

/**
 * Hook to manage view mode override preference
 * When true, forces desktop view regardless of device detection
 * When false/null, uses normal device detection
 */
export function useViewModeOverride() {
  const { storageItem: forceDesktop, setStorageItem: setForceDesktop } = useStorageItem<boolean>(
    StorageKey.FORCE_DESKTOP_VIEW,
    false
  )

  return {
    forceDesktop: forceDesktop ?? false,
    setForceDesktop
  }
}
